module.exports = __webpack_public_path__ + "static/media/notifications.dc48b518.svg";